import { render, staticRenderFns } from "./tyPage.vue?vue&type=template&id=402965ab&"
import script from "./tyPage.vue?vue&type=script&lang=js&"
export * from "./tyPage.vue?vue&type=script&lang=js&"
import style0 from "./tyPage.vue?vue&type=style&index=0&id=402965ab&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports